import Vue from 'vue';
import urlUtils from 'utils/url';
import { getProductSlug } from 'utils/product';


const retrieveOrder = body => Vue.axios.post('/order/token/', body);
const updateAddress = body => Vue.axios.post('/order/complete-address/', body);
const rechargeOrder = body => Vue.axios.post('/order/recharge/', body);
const createOpenEndedOrder = (body) => {
  const productName = urlUtils.getProductFromDomain();
  const productSlug = getProductSlug(productName);
  const productRouteSegment = productSlug === 'ORAAS' ? 'raas/optional' : productName;

  return Vue.axios.post(`/${productRouteSegment}/pcw-orders`, body);
};

export default {
  retrieveOrder,
  updateAddress,
  rechargeOrder,
  createOpenEndedOrder,
};
